import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }

  copy() {
    navigator.clipboard.writeText(this.textValue).then(() => {
      const icon = this.element.querySelector(".btn-copy i")
      if (icon) {
        icon.className = "bi bi-check-lg"
        setTimeout(() => { icon.className = "bi bi-clipboard" }, 1500)
      }
    })
  }
}
